module.exports = __webpack_public_path__ + "static/media/danger.1360d2ca.svg";